import React from 'react'
import ViewErrorProvider from './index.provider'
import ViewErrorScreenContent from './index.content'

const ViewErrorScreen: React.FC = () => {
  return (
    <ViewErrorProvider>
      <ViewErrorScreenContent />
    </ViewErrorProvider>
  )
}

export default ViewErrorScreen
